<template>
  <div>
    <h4 class="var-header">
      {{ $t("radio-btn-group.formatting") }}
    </h4>
    <FormatRadioButtons
      :formatList="whitelistedFormats"
      @format-changed="(name) => (selectedFormat = name)"
      @on-format-input="(name) => onFormatInput(name)"
      :_selectedFormat="selectedFormat"
      :examples="examples"
      :formatsForMethods="formatsForMethods"
    />
  </div>
</template>

<script>
import FormatRadioButtons from "@/components/FormatRadioButtons";
export default {
  data() {
    return {
      selectedFormat: "",
      examples: [],
      formatWhitelist: this.$store.state.formatWhiteList,
      selectedFormattingExample: null,
    };
  },
  props: {
    variable: {
      type: Object,
      required: true,
    },
    format: {
      type: String,
    },
    whitelist: Boolean,
    formatsForMethods: Boolean,
  },
  methods: {
    onFormatChange(format) {
      if (this.examples.find((e) => e.format == format))
        this.$emit("example-result", this.examples.find((e) => e.format == format).result || "");
      this.reloadExamples(true, format);
    },
    onFormatInput(format) {
      console.log("input changed: " + this.currentFormat.inputValues[0]);
      this.reloadExamples(true);
    },
    reloadExamples(formatChanges, methodFormats) {
      if (!this.formatsForMethods) {
        this.$nextTick(() => {
          this.$store
            .dispatch("getFormatExamples", {
              variable: this.variable,
              formats: this.formats.map((f) => {
                let format = f.name;
                if (f.inputValues) {
                  if (f.inputValues[0] !== undefined && f.inputValues[0] !== "") format += ";" + f.inputValues[0];
                  if (f.inputValues[1] !== undefined && f.inputValues[1] !== "") format += ";" + f.inputValues[1];
                }
                return format;
              }),
            })
            .then((examples) => {
              if (formatChanges) {
                this.$emit("format-changed", this.fullFormat, examples), (this.examples = examples);
              } else this.examples = examples;
            });
        });
      } else this.$emit("format-changed", this.fullFormat);
    },
    getFormats(type) {
      return [{ prettyName: "Ingen formatering", name: "", description: "", inputs: null }].concat(
        this.$store.state.variableFormats[type.toLowerCase()],
      );
    },
  },
  computed: {
    formats() {
      let formats;
      if (this.formatsForMethods) {
        // formats = this.$store.state.variableFormats[this.variable.type.toLowerCase()] // formats = this.variable.type === 'Date' || this.variable.custom ? [] : [{ name: '', inputValues: {}, description: '', inputs: [] }]
        formats = [
          { prettyName: "Ingen formatering", inputValues: {}, name: "", description: "", inputs: null },
        ].concat(this.$store.state.variableFormats[this.variable.type.toLowerCase()]); // formats = this.variable.type === 'Date' || this.variable.custom ? [] : [{ name: '', inputValues: {}, description: '', inputs: [] }]
      } else {
        formats =
          ["Date", "Number"].includes(this.variable.type)
            ? []
            : [
                {
                  name: "",
                  inputValues: {},
                  description: this.variable.custom
                    ? "Udregnet værdi"
                    : this.variable.value !== null
                    ? this.variable.value.toString()
                    : "Variablens værdi",
                  inputs: [],
                },
              ];
        formats = formats.concat(this.$store.state.variableFormats[this.variable.type.toLowerCase()]);
      }
      if (this.whitelist === true) {
        return formats.filter((f) => this.formatWhitelist.includes(f.name));
      }
      // return formats
      else return formats;
    },
    currentFormat() {
      return this.formats.find((f) => f.name === this.selectedFormat);
    },
    fullFormat() {
      // the format string with all its input values e.g 'stringify;2'
      let inputs = Object.values(this.currentFormat.inputValues).join(";");
      if (["Date", "Number"].includes(this.variable.type) && this.selectedFormat === "" && inputs.length) return inputs;
      else return this.selectedFormat + (!this.selectedFormat || !inputs.length ? "" : ";" + inputs);
    },
    whitelistedFormats() {
      if (this.whitelist === true) {
        return this.formats.filter((f) => this.formatWhitelist.includes(f.name));
      } else return this.formats;
    },
  },
  watch: {
    "variable.name": {
      immediate: true,
      handler(value) {
        if (value !== undefined) this.reloadExamples();
      },
    },
    variable: {
      immediate: true,
      handler() {
        this.formats.forEach((f) => this.$set(f, "inputValues", {}));
        let format = this.format;
        if (format === undefined || format == null || format === "") {
          this.selectedFormat = "";
          return;
        } else if (this.formatsForMethods) {
          // this.$set(this.currentFormat.inputValues, 0, format)
        } else if (this.variable.type === "Date" && this.formats.map((f) => f.name).indexOf(format) === -1) {
          // this is a custom date format, it doesn't have a name, just an input
          this.$set(this.currentFormat.inputValues, 0, format);
          this.selectedFormat = "";
        } else if (format.indexOf(";") > -1) {
          this.selectedFormat = format.substr(0, format.indexOf(";"));
          format
            .replace(this.selectedFormat + ";", "")
            .split(";")
            .forEach((input, index) => this.$set(this.currentFormat.inputValues, index, input));
        } else {
          this.selectedFormat = format || "";
        }
      },
    },
    selectedFormat: {
      handler() {
        this.onFormatChange(this.selectedFormat);
      },
    },
  },
  components: {
    FormatRadioButtons,
  },
};
</script>

<style lang="less">
.custom-control.custom-radio:not(:last-child) {
  margin-bottom: 10px;
}

.custom-control-label {
  color: #3d464a;
}

.radio-button-label-caption {
  font-size: 12px;
  color: var(--charcoal-50);
  margin-bottom: 0;
  margin-top: 4px;

  span {
    max-width: 226px;
    word-break: break-word;
  }
}

.var-header {
  user-select: none;
  padding: 6px 20px;
  padding-bottom: 6px;
  text-transform: uppercase;
}

.format-input {
  label {
    margin: 8px 0 4px 0;
  }

  input,
  select {
    width: 100%;
    &:focus,
    &:active {
      outline: none;
      box-shadow: none;
    }
  }
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: var(--orange-web);
  background-color: var(--orange-web);
}
</style>
